import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const TarifaInfoSkeleton = () => {
  return (
    <Grid item container xs={12}>
      <Skeleton
        variant="rectangular"
        width="50%"
        height={16}
        sx={{ borderRadius: 1 }}
      />
    </Grid>
  );
};

export default TarifaInfoSkeleton;
